import { render, staticRenderFns } from "./BaseToolTip.vue?vue&type=template&id=1ca54ff6&scoped=true"
import script from "./BaseToolTip.vue?vue&type=script&lang=js"
export * from "./BaseToolTip.vue?vue&type=script&lang=js"
import style0 from "./BaseToolTip.vue?vue&type=style&index=0&id=1ca54ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca54ff6",
  null
  
)

export default component.exports